import React, { useRef, useState } from "react";
import "./Gallery.css";

import g1sm from "../../assets/images/IMG_4463-sm.jpg";
import g1md from "../../assets/images/IMG_4463-md.jpg";
import g1lg from "../../assets/images/IMG_4463-lg.jpg";

import g2sm from "../../assets/images/IMG_4464-sm.jpg";
import g2md from "../../assets/images/IMG_4464-md.jpg";
import g2lg from "../../assets/images/IMG_4464-lg.jpg";

import g3sm from "../../assets/images/IMG_4465-sm.jpg";
import g3md from "../../assets/images/IMG_4465-md.jpg";
import g3lg from "../../assets/images/IMG_4465-lg.jpg";

import g4sm from "../../assets/images/IMG_4466-sm.jpg";
import g4md from "../../assets/images/IMG_4466-md.jpg";
import g4lg from "../../assets/images/IMG_4466-lg.jpg";

import g5sm from "../../assets/images/IMG_4467-sm.jpg";
import g5md from "../../assets/images/IMG_4467-md.jpg";
import g5lg from "../../assets/images/IMG_4467-lg.jpg";

import g6sm from "../../assets/images/IMG_4468-sm.jpg";
import g6md from "../../assets/images/IMG_4468-md.jpg";
import g6lg from "../../assets/images/IMG_4468-lg.jpg";

import g7sm from "../../assets/images/IMG_4469-sm.jpg";
import g7md from "../../assets/images/IMG_4469-md.jpg";
import g7lg from "../../assets/images/IMG_4469-lg.jpg";

import g8sm from "../../assets/images/IMG_4470-sm.jpg";
import g8md from "../../assets/images/IMG_4470-md.jpg";
import g8lg from "../../assets/images/IMG_4470-lg.jpg";

import g9sm from "../../assets/images/IMG_4471-sm.jpg";
import g9md from "../../assets/images/IMG_4471-md.jpg";
import g9lg from "../../assets/images/IMG_4471-lg.jpg";

import { useLanguage } from "../../context/LanguageContext";

const images = [
  { sm: g1sm, md: g1md, lg: g1lg },
  { sm: g2sm, md: g2md, lg: g2lg },
  { sm: g3sm, md: g3md, lg: g3lg },
  { sm: g4sm, md: g4md, lg: g4lg },
  { sm: g5sm, md: g5md, lg: g5lg },
  { sm: g6sm, md: g6md, lg: g6lg },
  { sm: g7sm, md: g7md, lg: g7lg },
  { sm: g8sm, md: g8md, lg: g8lg },
  { sm: g9sm, md: g9md, lg: g9lg },
];

const Gallery = () => {

    const { t } = useLanguage();


  const sliderRef = useRef(null);
  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const onMouseDown = (e) => {
    setIsDown(true);
    sliderRef.current.classList.add("dragging");
    setStartX(e.pageX - sliderRef.current.offsetLeft);
    setScrollLeft(sliderRef.current.scrollLeft);
  };

  const onMouseLeave = () => {
    setIsDown(false);
    sliderRef.current.classList.remove("dragging");
  };

  const onMouseUp = () => {
    setIsDown(false);
    sliderRef.current.classList.remove("dragging");
  };

  const onMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - sliderRef.current.offsetLeft;
    const walk = (x - startX) * 1.2;
    sliderRef.current.scrollLeft = scrollLeft - walk;
  };

  const scroll = (dir) => {
    const width = sliderRef.current.clientWidth;
    sliderRef.current.scrollBy({
      left: dir === "left" ? -width : width,
      behavior: "smooth",
    });
  };

  return (
    <section className="gallery-section" id="gallery">
      <div className="gallery-header" data-aos="fade-up">
      <h2>{t.gallery.title}</h2>
      </div>

      <div className="gallery-wrapper">
        <button className="gallery-btn left" onClick={() => scroll("left")}>‹</button>

        <div
          className="gallery-slider"
          ref={sliderRef}
          onMouseDown={onMouseDown}
          onMouseLeave={onMouseLeave}
          onMouseUp={onMouseUp}
          onMouseMove={onMouseMove}
        >
          {images.map((img, i) => (
            <div className="gallery-item" key={i}>
              <img
                src={img.sm}
                srcSet={`${img.sm} 600w, ${img.md} 1200w, ${img.lg} 2000w`}
                sizes="(max-width: 650px) 80vw, (max-width: 1000px) 60vw, 420px"
                alt={`Projet ${i + 1}`}
                loading="lazy"
              />
            </div>
          ))}
        </div>

        <button className="gallery-btn right" onClick={() => scroll("right")}>›</button>
      </div>
    </section>
  );
};

export default Gallery;
